module.exports = __webpack_public_path__ + "static/media/2_Ensure-optimal-wifi-performance.43db04a8.svg";